import { useRef } from 'react';

import Header from '../components/Header.js';
import Footer from '../components/Footer.js';
import Banner from '../components/Banner.js';

import Services from '../segments/Services.js';
import TechServices360 from '../segments/ConsultingService.js';
import Trust from '../segments/Trust.js';

import TestingService from '../services/TestingService';

const scrollToRef = (ref) => window.scrollTo(0, ref.current.offsetTop);

const Home = () => {

  const serviceRef = useRef(null);

  const openWhatsapp = () => {
    let url = "https://api.whatsapp.com/send/?phone=56982945099&text&app_absent=0";
    window.location.assign(url)
  }

  const goTo = (page) => {
    window.location.assign(page)
  }

  const openCall = () => {
    let url = "tel:0056997281587";
    window.open(url);
  }

  const testService = () => {
    TestingService.functionCustom().then((response) => {
      console.log(response);
    })
    .catch((err) => {
      console.log(err);
    });
  };

  return (
    <div className="App">
      <Header
        goTo={goTo}
        scrollToRef={scrollToRef}
        openWhatsapp={openWhatsapp}
        openCall={openCall}
      />
      <Banner
        serviceRef={serviceRef}
        goTo={goTo}
        scrollToRef={scrollToRef}
        testService={testService}
      />
      <Services
        serviceRef={serviceRef}
        goTo={goTo}
        scrollToRef={scrollToRef}
      />
      <Trust
        goTo={goTo}
      />
      <TechServices360/>
      <Footer
        openWhatsapp={openWhatsapp}
      />
    </div>
  );
}

export default Home;
